import { IFilterFacetItem } from '@impact/data';

export interface IFilterFacetPair {
    facet: string;
    option: IFilterFacetItem;
}

export interface IParamsOfArrays {
    [key: string]: string[];
}

export enum FILTER_SORTING {
    CREATEDDATE_ASCENDING = 'createdDate-asc',
    CREATEDDATE_DESCENDING = 'createdDate-desc',
    MAKE_ASCENDING = 'make.keyword-asc',
    MAKE_DESCENDING = 'make.keyword-desc',
    MODEL_ASCENDING = 'model.keyword-asc',
    MODEL_DESCENDING = 'model.keyword-desc',
    PRICE_ASCENDING = 'price-asc',
    PRICE_DESCENDING = 'price-desc',
}

export enum FILTER_FACET {
    BODYTYPES = 'bodyTypes.keyword',
    MAKE = 'make.keyword',
    MODEL = 'model.keyword',
    PURCHASE_OPTIONS = 'purchaseOption.keyword'
}
